
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import defensiveCopy from "@/util/defensive-copy";
import { ColorPickerType, GlobalColor } from "@/types/colors";
import { createVariableName } from "@/lib/colors/colors";
import ColorInput from "@/components/Reusable/CustomInputs/Color/ColorInput.vue";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import Icon from "@/components/UI/Icon.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import InlineRepeater from "@/components/Reusable/CustomInputs/InlineRepeater.vue";

@Component({
  components: { InlineRepeater, NiceButton, Icon, ColorInput, TextInput }
})
export default class GlobalColorsInput extends Vue {
  @Prop({
    default() {
      return [];
    }
  })
  value!: GlobalColor[];

  @Prop({
    default() {
      return {
        type: "solidOnly",
        name: "Color"
      };
    }
  })
  options!: {
    type: ColorPickerType;
    name: string;
  };

  get internalValue() {
    return this.value || [];
  }

  control = {
    options: {
      repeaterOptions: {
        buttonName: `Add ${this.options.name}`
      }
    }
  };

  updateValue(newValue: string | null, index: number) {
    const newColors = defensiveCopy(this.internalValue) || [];
    newColors[index].value = newValue;
    this.update(newColors);
  }

  updateLabel(newValue: string | null, index: number) {
    const newColors = defensiveCopy(this.internalValue) || [];
    newColors[index].label = newValue ?? "";

    this.update(newColors);
  }

  get defaultNewValue() {
    const generateLabel = (x: number) => `${this.options.name} #${x}`;

    let index = 0;
    do {
      index++;
      // eslint-disable-next-line
      var label = generateLabel(index);
    } while (this.isLabelAlreadyUsed(label));

    return {
      cssVariableName: createVariableName(label),
      label: label,
      value: null
    };
  }

  isLabelAlreadyUsed(label: string) {
    return this.value.find(c => c.label === label);
  }

  update(colors: GlobalColor[]) {
    this.$emit("input", colors);
  }

  remove(indexToRemove: number) {
    const newColors = defensiveCopy(this.internalValue) || [];
    newColors.splice(indexToRemove, 1);

    this.$emit("input", newColors);
  }
}
